
(function ( $ ) {

    $.convertToNumber = function (val, digit = 2) {
        if(isNaN(val)) {
            if(val) {
                val = val.replace(/,/g , '');
            }
            return $.toFixed(parseFloat(val), digit) * 1 || 0;
        }
        return $.toFixed(val, digit) * 1 || 0;
    }


    $.addComma = function (val, digit = 2) {
        if (val === "" || val === null) {
            return '';
        }

        let str_num = $.toFixed($.convertToNumber(val, digit), digit);

        if (digit > 3) {
            let num = str_num.split('.');
            return num[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + '.' + num[1];
        }

        return str_num.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }


    $.toFixed = function (num, digit = 2) {
        return Number(num).toFixed(digit);
    }


    $.fn.numbertor = function(options) {
        var opts = $.extend(true, {}, $.fn.numbertor.defaults, options);

        this.each(function () {
            opts.checkNumber(this, opts.conditions, opts.digit, opts.emptyOnBlur);
        });

        this.on('focus', function() {
            $(this).val($.convertToNumber(this.value, opts.digit) || (opts.emptyOnBlur ? ((this.value == '') ? '' : 0) : ''));
            $(this).select();
        });

        this.on('blur', function() {
            opts.checkNumber(this, opts.conditions, opts.digit, opts.emptyOnBlur);
        });
    };


    $.fn.numbertor.checkNumber = function(elm, conditions, digit, emptyOnBlur) {
        let num = (emptyOnBlur && elm.value == '') ? '' : $.convertToNumber(elm.value, digit);

        if (num != '') {
            if (num > 0 && !conditions.positiveInteger) {
                num = conditions.negativeInteger ? (num * -1) : 0;
            }
            else if (num < 0 && !conditions.negativeInteger) {
                num = 0;
                // num = conditions.positiveInteger ? (num * -1) : 0;
            }
        }

        if (num == 0 && !conditions.origin) {
            num = '';
        }

        $(elm).val($.addComma(num, digit));
    };


    $.fn.numbertor.defaults = {
        digit: 2,
        emptyOnBlur: false,
        conditions: {
          positiveInteger: true,
          negativeInteger: true,
          origin: true,
        },
        checkNumber: $.fn.numbertor.checkNumber,
    };

}( jQuery ));

// $(function () {
//     $('.number-price').each(function() {
//         $(this).val($.addComma(this.value, 2));
//     });
//
//     $('body').on('focus', '.number-price', function(){
//         $(this).select();
//     });
//
//     $('body').on('blur', '.number-price', function(){
//         $(this).val($.addComma(this.value, 2));
//     });
// });
